import { type Common } from '../common.js';
import { type SubmissionJobParams } from '../models/patient/order.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getExportSubmissionJobParamsForOrder(patientOrderId: string): Promise<SubmissionJobParams> {
    const url = this.common.constructPath(`/authorization/submissions/export/params`, {
      patientOrderId,
    });
    return await this.common.getJSON(url);
  }
}
